import React, { useState } from 'react';
import '../faq/faq.css';

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAnswer = (index) => {
    if (activeIndex === index) {
      setActiveIndex(null);
    } else {
      setActiveIndex(index);
    }
  };

  return (
    <div className="faq-container">
      <h1 className="faq-title">AstroBhagya - Frequently Asked Questions</h1>

      <div className="faq-item">
        <div
          className={`faq-question ${activeIndex === 0 ? 'active' : ''}`}
          onClick={() => toggleAnswer(0)}
        >
          1. How accurate is Astrology?
        </div>
        <div className={`faq-answer ${activeIndex === 0 ? 'show' : ''}`}>
          Astrology’s accuracy stems from the profound knowledge of planetary movements, constellations, and their influence on human behaviour. The science of astrology was developed thousands of years ago by wise sages who carefully observed the universe’s rhythms. The principles they established remain unchanged and continue to provide valuable insights. At AstroBhagya, we rely on the expertise of our skilled astrologers, who study these cosmic movements to offer you reliable predictions.
        </div>
      </div>

      <div className="faq-item">
        <div
          className={`faq-question ${activeIndex === 1 ? 'active' : ''}`}
          onClick={() => toggleAnswer(1)}
        >
          2. Why Should I Trust AstroBhagya for My Horoscope Analysis?
        </div>
        <div className={`faq-answer ${activeIndex === 1 ? 'show' : ''}`}>
          AstroBhagya offers trusted and accurate astrology services, highly rated by users across various platforms. We meticulously screen our astrologers to ensure that only the best experts are part of our network. Our services range from detailed Kundli matching and horoscope predictions to numerology and tarot readings. Moreover, if you encounter any issues, you can directly connect with our leadership team for resolution.
        </div>
      </div>

      <div className="faq-item">
        <div
          className={`faq-question ${activeIndex === 2 ? 'active' : ''}`}
          onClick={() => toggleAnswer(2)}
        >
          3. Are Astrology Predictions Reliable?
        </div>
        <div className={`faq-answer ${activeIndex === 2 ? 'show' : ''}`}>
          Astrology provides insights based on the positions and movements of the planets. However, it’s important to note that astrology doesn’t predict exact events but instead offers guidance on how certain planetary shifts may influence your life. For example, when a planet is in a favourable position, it is likely to bring positive outcomes; if not, it may indicate challenges. Accurate predictions are possible with the correct information and the expertise of a qualified astrologer.
        </div>
      </div>

      <div className="faq-item">
        <div
          className={`faq-question ${activeIndex === 3 ? 'active' : ''}`}
          onClick={() => toggleAnswer(3)}
        >
          4. Can Online Astrology Help Me Understand What Lies Ahead in My Future?
        </div>
        <div className={`faq-answer ${activeIndex === 3 ? 'show' : ''}`}>
          Online astrology follows the same principles as traditional astrology, allowing you to receive consultations remotely. By providing your birth details (such as your date, time, and place of birth), you can receive personalised reports. You can also directly connect with astrologers for more in-depth readings. Although the platform is modern, the process of prediction is grounded in ancient, trusted methods of analysing planetary and star positions.
        </div>
      </div>

      <div className="faq-item">
        <div
          className={`faq-question ${activeIndex === 4 ? 'active' : ''}`}
          onClick={() => toggleAnswer(4)}
        >
          5. What Topics Can I Discuss with an Astrologer?
        </div>
        <div className={`faq-answer ${activeIndex === 4 ? 'show' : ''}`}>
          You can ask an astrologer about any aspect of your life, including career, love, health, and personal growth. Our astrologers are well-versed in addressing a variety of questions, from determining your "manglik" status to suggesting auspicious timings for significant life events. No question is too big or small for astrology to provide guidance on.
        </div>
      </div>

      <div className="faq-item">
        <div
          className={`faq-question ${activeIndex === 5 ? 'active' : ''}`}
          onClick={() => toggleAnswer(5)}
        >
          6. What is the Duration of an Online Astrology Session?
        </div>
        <div className={`faq-answer ${activeIndex === 5 ? 'show' : ''}`}>
          Consultations at AstroBhagya are flexible, with no fixed duration, allowing you to discuss your questions without the pressure of time. Whether you need a quick consultation or a more thorough reading, our astrologers are available to provide detailed insights at your convenience.
        </div>
      </div>

      <div className="faq-item">
        <div
          className={`faq-question ${activeIndex === 6 ? 'active' : ''}`}
          onClick={() => toggleAnswer(6)}
        >
          7. Is There a Way to Change Astrology Predictions?
        </div>
        <div className={`faq-answer ${activeIndex === 6 ? 'show' : ''}`}>
          Astrological predictions can sometimes change if the astrologer makes an error in chart calculations or if incorrect information (such as birth details) is provided. Additionally, personal changes in behaviour can influence outcomes. For instance, by focusing on personal growth or making positive lifestyle changes, you may alter the impact of a planet’s influence.
        </div>
      </div>

      <div className="faq-item">
        <div
          className={`faq-question ${activeIndex === 7 ? 'active' : ''}`}
          onClick={() => toggleAnswer(7)}
        >
          8. What Are the Key Benefits of Choosing AstroBhagya’s Astrology Services?
        </div>
        <div className={`faq-answer ${activeIndex === 7 ? 'show' : ''}`}>
          Using AstroBhagya offers numerous benefits. For first-time users, you can enjoy a 50% discount on your initial consultation. Our astrologers provide valuable insights into various aspects of your life, such as career advice, relationship guidance, and health recommendations. These insights can help you navigate life’s challenges with more confidence and clarity.
        </div>
      </div>

      <div className="faq-item">
        <div
          className={`faq-question ${activeIndex === 8 ? 'active' : ''}`}
          onClick={() => toggleAnswer(8)}
        >
          9. Which App Offers the Best Kundli Predictions?
        </div>
        <div className={`faq-answer ${activeIndex === 8 ? 'show' : ''}`}>
          AstroBhagya offers one of the best online Kundli services. Our Kundli is prepared by expert astrologers and is available in multiple languages. It covers every aspect of your life, including past, present, and future insights. The Kundli provides recommendations based on your unique planetary alignments, helping you understand your life’s challenges and opportunities.
        </div>
      </div>

      <div className="faq-item">
        <div
          className={`faq-question ${activeIndex === 9 ? 'active' : ''}`}
          onClick={() => toggleAnswer(9)}
        >
          10. Can I Trust the AstroBhagya App for Accurate Predictions?
        </div>
        <div className={`faq-answer ${activeIndex === 9 ? 'show' : ''}`}>
          The AstroBhagya app is designed to provide reliable astrology services, from live consultations with top astrologers to free daily, weekly, and monthly horoscopes. In addition to consultations, we also offer free Kundli, matchmaking services, and astrology products like Rudraksha, Yantras, and gemstones. With a user-friendly interface, it’s your one-stop platform for all your astrology needs.
        </div>
      </div>

      <div className="faq-item">
        <div
          className={`faq-question ${activeIndex === 10 ? 'active' : ''}`}
          onClick={() => toggleAnswer(10)}
        >
          11. What is the Cost of an Astrology Session on AstroBhagya?
        </div>
        <div className={`faq-answer ${activeIndex === 10 ? 'show' : ''}`}>
          AstroBhagya offers competitive pricing to suit your budget. Consultation fees range from as little as ₹10 per minute to ₹250 per minute, depending on the astrologer’s experience and expertise. We also offer promotions such as “First Chat Free” for new users, making astrology services both affordable and accessible.
        </div>
      </div>

      <div className="faq-item">
        <div
          className={`faq-question ${activeIndex === 11 ? 'active' : ''}`}
          onClick={() => toggleAnswer(11)}
        >
          12. Are Astrology Apps Reliable?
        </div>
        <div className={`faq-answer ${activeIndex === 11 ? 'show' : ''}`}>
          Astrology apps like AstroBhagya are reliable because they are based on expert knowledge and authentic astrology practices. Our astrologers undergo rigorous screening to ensure they provide accurate readings and advice. With millions of satisfied users, AstroBhagya continues to offer genuine services, including live consultations, free horoscopes, and personalised predictions.
        </div>
      </div>
    </div>
  );
};

export default Faq;
